/**
 * Feature flags.
 *
 * Login is switched OFF while it is being reworked. To bring it back, build
 * the client with VITE_LOGIN_ENABLED=true (and set LOGIN_ENABLED=true on the
 * server — see server/src/lib/features.ts).
 */
export const LOGIN_ENABLED = import.meta.env.VITE_LOGIN_ENABLED === 'true';
